import { NameDto } from './NameDto'

export enum SwapFreeLevelEnum {
  Green = 1,
  Orange = 2,
  Red = 3,
}

export type SwapFreeLevelType = NameDto<SwapFreeLevelEnum>

export const isRedSwapFreeLevel = (level: SwapFreeLevelType | null | undefined) => {
  return level?.id === SwapFreeLevelEnum.Red
}
